import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.keys.js";
import config from 'utils/config';
import isMultiDomain from 'utils/isMultiDomain';
import { hasPrivilege, PLAYLIST_WRITE } from 'utils/privileges';
function getNextSteps(_ref) {
  var _playlist$tags, _playlist$topics;
  var playlist = _ref.playlist,
    enableNextSteps = _ref.enableNextSteps;
  var metadata = {
    thumbnailId: playlist === null || playlist === void 0 ? void 0 : playlist.thumbnailId,
    description: playlist === null || playlist === void 0 ? void 0 : playlist.description,
    tagIds: playlist === null || playlist === void 0 ? void 0 : (_playlist$tags = playlist.tags) === null || _playlist$tags === void 0 ? void 0 : _playlist$tags.map(function (tag) {
      return tag.id;
    }),
    topicIds: playlist === null || playlist === void 0 ? void 0 : (_playlist$topics = playlist.topics) === null || _playlist$topics === void 0 ? void 0 : _playlist$topics.map(function (topic) {
      return topic.id;
    })
  };
  var hasContent = Boolean(playlist === null || playlist === void 0 ? void 0 : playlist.contentCount);
  var hasAudience = (playlist === null || playlist === void 0 ? void 0 : playlist.audience) !== 'admin';
  var hasCompleteMetadata = Object.keys(metadata).every(function (key) {
    if (Array.isArray(metadata[key])) {
      return metadata[key].length > 0;
    }
    return metadata[key] !== null && metadata[key] !== undefined;
  });
  var hasAllCurationData = hasContent && hasAudience && hasCompleteMetadata;
  var showNextSteps = playlist && enableNextSteps && hasPrivilege(PLAYLIST_WRITE) && !isMultiDomain(playlist) && !playlist.isDeleted && config.curationChecklist && !hasAllCurationData;
  return {
    showNextSteps: showNextSteps,
    hasContent: hasContent,
    hasAudience: hasAudience,
    metadata: metadata,
    hasCompleteMetadata: hasCompleteMetadata
  };
}
export default getNextSteps;